<template>
    <section id="page4">
        <div class="container">
            <div class="col-left">
                <lottie-player :src="`animas/0/page05.json`" v-if="persona==0" ref="lottie" id="page5anima0" class="anima"
                        loop="false"
                        transparent
                        >
                </lottie-player>
                <lottie-player :src="`animas/1/page05.json`" v-if="persona==1" ref="lottie" id="page5anima1" class="anima"
                        loop="false"
                        transparent
                        >
                </lottie-player>
                
            </div>
            
            <div class="col-right">
                <h2>
                    Quem é a <br>LG lugar de gente?
                </h2>
                <p>
                    Há mais de 37 anos no mercado, a LG lugar de gente possui uma oferta completa e integrada de produtos para gestão do capital humano. É a maior HR Tech do Brasil e está entre os maiores fornecedores para HCM do mundo, contribuindo com a transformação digital do RH em mais de 2 mil empresas de diferentes portes e segmentos de forma direta e indireta.  
                    <br><br>
                    Ajudar as empresas a desenvolverem seus talentos é um dos objetivos da LG lugar de gente. Por isso, oferecemos soluções inovadoras, que revolucionam a aprendizagem corporativa de forma lúdica, leve e personalizada. Tudo isso com apoio de um time de especialistas que criam conteúdos adaptados para o seu negócio. 
                </p>
            </div>
        </div>
        <div class="container container-bottom" data-aos="fade" data-aos-delay="600">
            <div class="swipercards">
                <swiper ref="mySwiper" :options="swiperOptions" @slideChange="runOnChange">
                    <swiper-slide>
                        <article>
                            <div class="card">
                                <img src="@/assets/img/page4-icon1.svg" alt="">
                                <p>
                                    Com nossas soluções, apoiamos empresas a desenvolver, selecionar, integrar e engajar pessoas.
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card">
                                <img src="@/assets/img/page4-icon2.svg" alt="">
                                <p>
                                    Trabalhamos de forma consultiva, apoiando o cliente na construção e implementação do projeto e nas definições que geram impacto para o resultado final.
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card">
                                <img src="@/assets/img/page4-icon3.svg" alt="">
                                <p>
                                    Construímos soluções personalizadas com a estrutura planejada para as necessidades específicas dos clientes.
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <swiper-slide>
                        <article>
                            <div class="card">
                                <img src="@/assets/img/page4-icon4.svg" alt="">
                                <p>
                                    Contamos com um portfólio de produtos já prontos para serem aplicados.
                                </p>
                            </div>
                        </article>
                    </swiper-slide>
                    <!-- <div class="swiper-button-prev swiper-button-prev1" slot="button-prev"></div>
                    <div class="swiper-button-next swiper-button-next1" slot="button-next"></div> -->
                </swiper>
                <div class="bullets">
                    <div class="swiper-pagination swiper-pagination1" slot="pagination"></div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
// import gsap from "gsap";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import { create } from '@lottiefiles/lottie-interactivity';
export default {
    props: ['persona'],
    data() {
        return {
            swiperOptions: {
                slidesPerView: 1,
                centeredSlides: false,
                pagination: {
                    el: '.swiper-pagination1',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next1',
                    prevEl: '.swiper-button-prev1'
                },
                breakpoints: {
                    1140: {
                        slidesPerView: 4,
                    },
                    900: {
                        slidesPerView: 3,
                    }
                }
            }
        }
    },
    computed: {
        swiper() {
        return this.$refs.mySwiper.swiper
        }
    },
    methods: {
        runOnChange(evt) {
            if(this.$refs.mySwiper.$swiper.activeIndex==(this.$refs.mySwiper.$children.length-1)){
                // console.log("FINALIZOU");
            }
        }
    },
    mounted() {
        
        console.log("REF = ",  this.$refs.lottie);
        if(this.persona == 0) {
            this.$refs.lottie.addEventListener('load', function() {
                create({
                        mode:"scroll",
                        player: '#page5anima0',
                        actions: [
                            {
                                visibility: [0, .2],
                                type: "play"
                            }
                        ],
                });
            })
        } else {
            this.$refs.lottie.addEventListener('load', function() {
                create({
                        mode:"scroll",
                        player: '#page5anima1',
                        actions: [
                            {
                                visibility: [0, .2],
                                type: "play"
                            }
                        ],
                });
            })
        }
    }
}
</script>
<style lang="scss" scoped>
section {
    background-color: #3E5FAC;
    color: white;
    .container-bottom {
        .swipercards {
            max-width: 100%;
            display: block;
            padding-bottom: 60px;
            article {
                max-width: 248px; 
                background-color: white;
                color: #111A2E;
                margin-left: 10px;
                margin-right: 10px;
                border-radius: 28px;
                box-shadow: 0px 10px 16px 0px rgba(0,0,0,0.16);
                border: 1px solid #B2B2B2;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                overflow-y: hidden;
                // background-color: red;
                // color: white;
                text-align: center;
                // width: 902px;
                height: 301px;
                padding-left: 30px;
                padding-right: 30px;
                padding-top: 15px;
                padding-bottom: 35px;
                .card {
                    
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    gap: 30px;
                    flex: 1;
                   
                    text-align: center;
                    // flex-basis: 25%;
                    
                }
            }
            .bullets {
                display: none;
                height: 100px;
                justify-content: center;
            }
        }
    }
    .container {
        padding-top: 35px;
        padding-bottom: 35px;
        .col-left {
            // display: flex;
            // justify-content: center;
            // align-content: center;
            flex-basis: 50%;
            .persona {
                padding-bottom: 46px;
                max-width: 100%;
            }
            h2 {
                padding-bottom: 30px;
            }
            .anima {
                max-width: 394px;
                padding-bottom: 45px;
                margin: 0 auto;
            }
            
        }
        
        .col-right {
            flex-basis: 50%;
            h2 {
                padding-bottom: 30px;
            }
            .cards {
                
                display: flex;
                gap: 30px;
                flex-wrap: wrap;
                .card {
                    background-color: white;
                    color: #111A2E;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    gap: 30px;
                    flex: 1;
                    padding: 30px 20px;
                    border-radius: 28px;
                    box-shadow: 0px 10px 16px 0px rgba(0,0,0,0.16);
                    border: 1px solid #B2B2B2;
                    text-align: center;
                    // flex-basis: 25%;
                    
                }
            }
        }
        
    }
    @media only screen and (max-width: 1140px) {
        .container-bottom {
            .swipercards {
                max-width: 100vw;
                padding-bottom: 0;
                .bullets {
                    display: flex;
                }
            }
            
        }
        .container {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .col-left {
                
                flex-basis: 100%;
                padding-bottom: 30px;
                text-align: center;
            }
            .col-right {
                flex-basis: 100%;
            }
        }
    }
    @media only screen and (max-width: 992px) {
        .container {
            .col-right {
                .cards {
                    .card {
                        flex-basis: 36%;
                    }
                }
                .textos {
                    .texto {
                        flex-basis: 44%;
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 600px) {
        .container {
            .swipercards {
                display: block;
                width: 100%;
                article {
                    margin-left: 10px;
                    margin-right: 10px;
                    border-radius: 28px;
                    box-shadow: 0px 10px 16px 0px rgba(0,0,0,0.16);
                    border: 1px solid #B2B2B2;
                    display: flex;
                    flex-direction: column;
                    // justify-content: center;
                    align-items: center;
                    overflow-y: hidden;
                    // background-color: red;
                    // color: white;
                    text-align: center;
                    // width: 902px;
                    // height: 253px;
                    padding-left: 30px;
                    padding-right: 30px;
                    padding-top: 15px;
                    padding-bottom: 15px;
                }
                .bullets {
                    height: 100px;
                    display: flex;
                    justify-content: center;
                }
            }
                
            .col-right {
                
                .cards {
                    display: none;
                    .card {
                        flex-basis: 100%;
                        
                    }
                }
                .textos {
                    padding-top: 0;
                    .texto {
                        flex-basis: 100%;
                    }
                }
            }
            .col-left {
                padding-bottom: 50px;
                .anima {
                    max-width: calc(100% - 30px);
                    // padding-right: 30px;
                }
            }
        }
    }
}
</style>